import { Pipe, PipeTransform } from '@angular/core';
import { CommentChatModel } from '@dta/shared/models-api-loop/comment/comment.model';
import { SharedTagReactionModel } from '@dta/shared/models-api-loop/shared-tag/shared-tag.model';

@Pipe({
  name: 'hasReactions'
})
export class HasReactionsPipe implements PipeTransform {
  transform(comment: CommentChatModel): boolean {
    const reactionTags =
      (comment.sharedTags?.tags?.resources?.filter(
        tag => tag.$type === SharedTagReactionModel.type
      ) as SharedTagReactionModel[]) ?? [];

    return !!reactionTags.length;
  }
}
